<script>
import { mapState } from 'vuex';
import ContactForm from '../../components/contactForm.vue';
import GalleryInfo from '../../components/galleryInfo.vue';
import Length from '../../components/length.vue';
import Loading from '../../components/loading.vue';

export default {
    name: "worksDetail",
    data() {
        return {
            length: 0,
            detail: {},
            isLoading: false,
            history: window.history.length,
            isLoadingAddCart: false,
        };
    },
    computed: {
        ...mapState(['galleryHome'])
    },
    components: {
        ContactForm,
        GalleryInfo,
        Length,
        Loading
    },
    mounted() {
        this.getData();
    },
    destroyed() {},
    watch: {},
    methods: {
        getData() { 
            this.isLoading = true;
            this.$store.dispatch('getGalleryWorksDetail', {
                id: this.$route.query.id
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) {
                    this.detail = result.data;
                    if (result.data.qty > 0) { 
                        this.length = 1;
                    }
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        addCart() { 
            // 未登录，跳转登录
            if (!localStorage.getItem('token')) { 
                this.toLogin();
                return;
            }
            // 
            if (this.isLoadingAddCart) { 
                return;
            }
            this.isLoadingAddCart = true;
            this.$store.dispatch('addCart', {
                id: this.detail.id,
                type: 2,
            }).then((result) => {
                this.isLoadingAddCart = false;
                if (result.code == 100) {
                    this.$showToast({ text: '添加成功' });
                } else if (result.code == 90) {
                    this.$showToast({ text: '登录凭证已失效' });
                    this.toLogin();
                } else if (result.code == 101) { 
                    this.$showToast({ text: '添加失败，库存不足' });
                } else if (result.code == 102) { 
                    this.$showToast({ text: '商品已经在购物车了' });
                }
            }).catch((err) => {
                this.isLoadingAddCart = false;
                this.$showToast({ text: '添加失败' });
            });
        },
        // 跳转登录
        toLogin() { 
            this.$router.push({
                path: '/login',
                query: {
                    redirect: this.$route.fullPath
                }
            })
        },
    },
};
</script>

<template>
    <div class="works_detail">
        <div class="layout_body">
            <!-- banner -->
            <div class="banner only_pc">
                <div class="layout_bg" :style="`background-image: url(${galleryHome.work_banner});`"></div>
            </div>
            <div class="layout_main">
                <div class="layout_content" v-if="isLoading">
                    <Loading/>
                </div>
                <div class="layout_content" v-else>
                    <p class="breadcrumb only_pc">
                        <router-link to="/gallery">A<sup>+</sup> Studio Gallery</router-link> / 
                        <router-link to="/gallery/works">作品总览</router-link> / 
                        <router-link :to="`/gallery/artist/detail?id=${detail.artist_id}`">{{ detail.artist_name }}</router-link> / 
                        <router-link :to="`/gallery/works?artist=${detail.artist_id}`">作品</router-link> / 
                        {{ detail.name }}
                    </p>
                    <div class="content flex">
                        <div class="left">
                            <div class="cover only_pc">
                                <div class="layout_bg" :style="`background-image: url(${detail.image});`"></div>
                            </div>
                            <img :src="detail.image" alt="" class="cover only_mobile"/>
                            <p class="desc only_pc" v-html="$textToHtml(detail.desc)"></p>
                        </div>
                        <div class="right flex flex_column justify_between">
                            <div class="title">{{ detail.name }}</div>
                            <div class="info flex flex_column justify_between">
                                <div class="item only_pc">
                                    <p class="name">作品名称</p>
                                    <p class="pun">：</p>
                                    <p>{{ detail.name }}</p>
                                </div>
                                <div class="item">
                                    <p class="name">艺术家</p>
                                    <p class="pun">：</p>
                                    <p>{{ detail.artist_name }}</p>
                                </div>
                                <div class="item" v-if="detail.type">
                                    <p class="name">类型</p>
                                    <p class="pun">：</p>
                                    <p>{{ detail.type }}</p>
                                </div>
                                <div class="item" v-if="detail.size">
                                    <p class="name">尺寸</p>
                                    <p class="pun">：</p>
                                    <p>{{ detail.size }}</p>
                                </div>
                                <div class="item" v-if="detail.material">
                                    <p class="name">材质</p>
                                    <p class="pun">：</p>
                                    <p>{{detail.material}}</p>
                                </div>
                                <div class="item">
                                    <p class="name">价格</p>
                                    <p class="pun">：</p>
                                    <p v-if="detail.price == '0.00'">免费</p>
                                    <p v-else>RMB {{ detail.price }}</p>
                                </div>
                                <!-- <div class="item">
                                    <Picker :data="logistics" v-model="activeIndex"/>
                                </div> -->
                                <div class="item">
                                    <Length v-model="length" :min="detail.qty > 0 ? 1 : 0" :max="detail.qty"/>
                                </div>
                                <div class="item btn_group">
                                    <div class="btn layout_flex_center" v-if="isLoadingAddCart">
                                        <Loading type="smail"/>
                                    </div>
                                    <div class="btn layout_flex_center" v-else @click="addCart">添加到购物车</div>
                                    <div class="btn layout_flex_center">立即购买</div>
                                </div>
                            </div>
                            <div class="flex justify_end only_pc" v-if="history > 2"><div class="btn_back" @click="$router.go(-1)">返回</div></div>
                            <div class="flex justify_end only_pc" v-else><router-link class="btn_back" to="/gallery/works">返回</router-link></div>
                        </div>
                        <p class="desc only_mobile" v-html="$textToHtml(detail.desc)"></p>
                    </div>
                </div>
            </div>
        </div>
        <ContactForm from="画廊"/>
        <GalleryInfo/>
    </div>
</template>

<style scoped lang="scss">
.banner{
    height: 4.8rem;
}
.layout_content{
    @media only screen and (max-width: 750px) {
        padding: .3rem 0;
    }
}
.breadcrumb{
    font-size: .2rem;
    color: #666;
    margin-bottom: .3rem;
}
.content{
    gap: 1.2rem;
    @media only screen and (max-width: 750px) {
        flex-direction: column;
        gap: .3rem;
        .title{
            text-align: center;
            font-size: .32rem;
            margin-bottom: .3rem;
        }
    }
    .left{
        width: 5rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
        }
    }
    .cover{
        width: 5rem;
        height: 4.8rem;
        margin-bottom: .2rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
            height: auto;
        }
    }
    .desc{
        font-size: .2rem;
        color: #666;
        @media only screen and (max-width: 750px) {
            font-size: .28rem;
        }
    }
    .right{
        flex: 1;
    }
    .info{
        height: 4.8rem;
        @media only screen and (max-width: 750px) {
            height: auto;
            gap: .3rem;
        }
        .item{
            display: flex;
            align-items: center;
            font-size: .2rem;
            // margin-bottom: .2rem;
            .name{
                width: 4em;
                text-align: justify;
                text-align-last: justify;
            }
            .pun{
                margin: 0 .1rem;
            }
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
                .name{
                    width: 3em;
                }
            }
        }
        .btn_group{
            gap: .3rem;
            // margin-bottom: .3rem;
            .btn{
                box-sizing: content-box;
                border: 1px solid #000;
                padding: 0 .3rem;
                height: .4rem;
                font-size: .18rem;
                cursor: pointer;
            }
            @media only screen and (max-width: 750px) {
                .btn{
                    flex: 1;
                    font-size: .26rem;
                    height: .6rem;
                }
            }
        }
    }
    .btn_back{
        font-size: .18rem;
        color: #666;
        border-bottom: 1px solid #666;
        cursor: pointer;
    }
}
</style>